































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { DataGrid, PageTitle } from '@questelservices/common-vue';
import { DxButton, DxPopup, DxProgressBar } from 'devextreme-vue';
import ClientSummary from '@/components/activity-planner/client-summary.vue';
import {
  DxColumn,
  DxFilterRow,
  DxLoadPanel,
  DxPager,
  DxPaging,
  DxRemoteOperations
} from 'devextreme-vue/data-grid';
import ClaimDialog from '@/views/activity-planner_claim-dialog.vue';
import ClaimedWork from '@/components/activity-planner/claimed-work.vue';
import BrowseModeSelectionDialog from '@/components/browse-mode/browse-mode-selection-dialog.vue';
import { MatterWorkTypeEnum } from '@/models/matter-work/MatterWorkTypeEnum';
import { ActivityPlannerService } from '@/service/ActivityPlannerService';
import DevExpress from 'devextreme/bundles/dx.all';
import { BatchTypeEnum } from '@/models/batch/BatchTypeEnum';

@Component({
  components: {
    BrowseModeSelectionDialog,
    ClaimDialog,
    ClaimedWork,
    ClientSummary,
    DataGrid,
    DxButton,
    DxColumn,
    DxFilterRow,
    DxLoadPanel,
    DxPager,
    DxPaging,
    DxPopup,
    DxProgressBar,
    DxRemoteOperations,
    PageTitle
  }
})
export default class Coding extends Vue {
  public $refs: Vue['$refs'] & {
    availableWorkDataGrid?: DataGrid;
    availableSavingsReportWorkDataGrid?: DataGrid;
    claimedWork?: ClaimedWork;
  } = {};

  public readonly savingsReportTableRef: string = 'availableSavingsReportWorkDataGrid';
  public readonly browseModeDialogRef: string = 'browseModeDialogRef';
  public readonly claimDialogRef: string = 'claimDialogRef';
  public readonly clientSummaryRef: string = 'clientSummaryRef';
  public readonly codingWorkType: MatterWorkTypeEnum = MatterWorkTypeEnum.Coding;
  public readonly productionBatchType: BatchTypeEnum = BatchTypeEnum.Production;
  public readonly savingsReportBatchType: BatchTypeEnum = BatchTypeEnum.SavingsReport;

  activityPlannerService: ActivityPlannerService;  
  productionDataStoreOptions:  DevExpress.data.CustomStoreOptions;
  savingsReportStoreOptions:  DevExpress.data.CustomStoreOptions;

  savingsReportTableVisible: boolean = true;

  constructor() {
    super();

    this.activityPlannerService = new ActivityPlannerService('/api');
    this.productionDataStoreOptions = {     
        load: loadOptions => 
          this.activityPlannerService
            .getAvailableWork(loadOptions, MatterWorkTypeEnum.Coding, BatchTypeEnum.Production)        
    };

    this.savingsReportStoreOptions = {         
        load: loadOptions => 
          this.activityPlannerService
            .getAvailableWork(loadOptions, MatterWorkTypeEnum.Coding, BatchTypeEnum.SavingsReport)     
            .then(result => {              
              let showSavingsTable = result.data.length > 0 ? true : false;
              this.updateDisplay(showSavingsTable);
              return result;
            })   
    };
  }
  
  updateDisplay(isVisble: boolean) {
    this.savingsReportTableVisible = isVisble;
  }

  private get savingsReportTable() {
    return this.$refs[this.savingsReportTableRef] as DataGrid;
  }

  private get browseModeDialog() {
    return this.$refs[this.browseModeDialogRef] as BrowseModeSelectionDialog;
  }

  private get claimDialog() {
    return this.$refs[this.claimDialogRef] as ClaimDialog;
  }

  private get clientSummary() {
    return this.$refs[this.clientSummaryRef] as ClientSummary;
  }

  claimWorkRow(row: any, all: boolean, matterWorkType: MatterWorkTypeEnum) {
    this.claimDialog.clientId = row.ClientId;
    this.claimDialog.matterWorkType = matterWorkType;
    this.claimDialog.isClaimAll = all;
    this.claimDialog.show();
  }

  onDataErrorOccurred(e: any) {
    if (e != null && e.error != null) {
      e.error.message = 'Failed to load data.';
    }
  }

  refreshDataGrid() {
    if (this.$refs.availableWorkDataGrid) {
      (this.$refs.availableWorkDataGrid as any).refreshDataGrid();
    }

    if (this.$refs.availableSavingsReportWorkDataGrid) {
      (this.$refs.availableSavingsReportWorkDataGrid as any).refreshDataGrid();
    }

    if (this.$refs.claimedWork) {
      (this.$refs.claimedWork as any).refreshDataGrid();
    }
  }

  openBrowseModeDialog() {
    this.browseModeDialog.show();
  }

  showClientSummary() {
    this.clientSummary.show();
  }
}
